export default __webpack_public_path__ + "media/Seasoning-Other.0dfaa8e6.png";